<template lang="pug">
section#eventos.ev
    oc-calendar(v-for='(ce,idx) in currentEvents' :title='ce.title' :datesContent='ce.dates' :order='ce.order' :key='idx')
    oc-calendar( :detailed='olderEvents.detailed' :title='olderEvents.title' :datesContent='olderEvents.dates')
    oc-arrow(:urlRef='nextSection')
</template>

<script>
import EVENT from '@/constants/event-constants'
import OcCalendar from '@/components/landing/events/Calendar.vue'
import OcArrow from '@/components/shared/Arrow.vue'

export default {
    components: {
        OcCalendar, OcArrow
    },
    data () {
        return {
            nextSection: '#membresias',
            currentEvents: [
                {
                    title: 'Eventos 2025',
                    order: EVENT.ASC_ORDER,
                    dates: [
                        {
                            startsIn: new Date('1/21/2025'),
                            name: 'Diplomado Ortografía Financiera - Jueves',
                            htmlDetail: '<div style="text-align: center;"><img class="img-fluid" src="/img/ev/2021/of_2021.jpeg"><br><div style="text-align: center;"><img class="img-fluid" src="/img/ev/2021/dof_2021_jueves.jpeg"></div></div>'
                        },
                        {
                            startsIn: new Date('1/23/2025'),
                            name: 'Diplomado Ortografía Financiera - Sábados',
                            htmlDetail: '<div style="text-align: center;"><img class="img-fluid" src="/img/ev/2021/dof_2021_sab.jpeg"></div>'
                        },
                        {
                            startsIn: new Date('2/12/2025'),
                            name: 'Diplomado Mujeres Adas sin "H"',
                            htmlDetail: '<div style="text-align: center;"><img class="img-fluid" src="/img/ev/2021/ma_2021.jpeg"></div>'
                        },
                        {
                            startsIn: new Date('2/14/2025'),
                            name: 'Diplomado Ortografía Cerebral',
                            htmlDetail: '<div style="text-align: center;"><img class="img-fluid" src="/img/ev/2021/doc_2021.jpeg"></div>'
                        },
                        {
                            startsIn: new Date('9/6/2025'),
                            name: 'Café con Mirna - Cómo aprender a vivir. Sin soledad',
                            htmlDetail: '<div style="text-align: center;"><img class="img-fluid" src="/img/ev/2025/cm-cavss.jpeg"></div>'
                        },
                        {
                            startsIn: new Date('10/4/2025'),
                            name: 'Café con Mirna - Porque me limito y no pongo límites',
                            htmlDetail: '<div style="text-align: center;"><img class="img-fluid" src="/img/ev/2025/cm-pmlynpl.jpeg"></div>'
                        },
                        {
                            startsIn: new Date('11/1/2025'),
                            name: 'Café con Mirna - Cómo aprender a vivir. Sin soledad',
                            htmlDetail: '<div style="text-align: center;"><img class="img-fluid" src="/img/ev/2025/cm-cavss.jpeg"></div>'
                        },
                        {
                            startsIn: new Date('12/6/2025'),
                            name: 'Café con Mirna - Porque me limito y no pongo límites',
                            htmlDetail: '<div style="text-align: center;"><img class="img-fluid" src="/img/ev/2025/cm-pmlynpl.jpeg"></div>'
                        }
                    ]
                }
            ],
            olderEvents: {
                    title: 'Años anteriores',
                    detailed: false,
                    dates: [
                        {
                            name: 'Ortografía Cerebral Recargado'
                        },
                        {
                            name: 'Cómo programar efectivamente tus propósitos y deseos'
                        },
                        {
                            name: 'Presentación de Libro'
                        },
                        {
                            name: 'Ortografía Financiera – Los Cabos BCS'
                        },
                        {
                            name: 'Curso Ortografía Cerebral - Chihuahua'
                        },
                        {
                            name: 'Curso de Lectura del Inconsciente con Cuarzos'
                        },
                        {
                            name: 'Curso Perdón y Agradecimiento'
                        },
                        {
                            name: 'Curso Mujeres Adas sin H'
                        },
                        {
                            name: 'Curso Ortografía Cerebral'
                        },
                        {
                            name: 'Curso Ortografía Cerebral – Mónica Delgado'
                        },
                        {
                            name: 'Diplomado de Ortografía Financiera'
                        },
                        {
                            name: 'Diplomado PsicoOrtoNeuroIngenieria del Pensamiento'
                        },
                        {
                            name: 'Diplomado Perdón y Agradecimiento'
                        },
                        {
                            name: 'Diplomado Mujeres Adas sin "H"'
                        },
                        {
                            name: 'Diplomado de Ortografía Financiera'
                        },
                        {
                            name: 'Taller de Ortografía Cerebral (Mónica Delgado)'
                        },
                        {
                            name: 'Taller de Ortografía Cerebral (Elizabeth Arellano)'
                        },
                        {
                            name: 'Certificación de instructor de ortografía financiera'
                        }
                    ]                    
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/landing/Events.vue